var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    d: "M16 19.5556C17.931 19.5556 19.7828 20.3048 21.1482 21.6384C21.6433 22.1219 22.0597 22.6679 22.3894 23.2574C22.7751 23.947 22.7339 25.0578 22.4167 26.1421M16 19.5556C14.069 19.5556 12.2172 20.3048 10.8518 21.6384C10.3567 22.1219 9.94029 22.6679 9.61059 23.2574C9.22486 23.947 9.26614 25.0578 9.5833 26.1421M16 19.5556C18.5131 19.5556 20.5505 17.5657 20.5505 15.1111C20.5505 12.6565 18.5131 10.6667 16 10.6667C13.4869 10.6667 11.4495 12.6565 11.4495 15.1111C11.4495 17.5657 13.4869 19.5556 16 19.5556ZM22.4167 26.1421C25.7725 24.0146 28 20.2674 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 20.2674 6.22754 24.0146 9.5833 26.1421M22.4167 26.1421C20.5609 27.3187 18.36 28 16 28C13.64 28 11.4391 27.3187 9.5833 26.1421",
    stroke: "white",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/userCircle.e73f10b12ca8e0102caec8cb21ea7ecc.svg";
export { ForwardRef as ReactComponent };